import { List as iList, fromJS } from 'immutable';
const initialState = iList([]);

export function tags(state = initialState, action) {
  switch (action.type) {
    case 'ADD_TAG_STARTING':
      const mappedTags = state.toJS().length ? state.toJS().map(tagObj => tagObj.tag) : [];
      if (mappedTags.indexOf(action.payload.tagName) === -1) return state.push({ _id: undefined, tag: action.payload.tagName });
      return state;
    case 'GET_TAGS':
      return iList(action.payload.tags);
    case 'DELETED_TAG':
      const removeTag = state.toJS().filter(tag => tag._id !== action.payload.tadId);
      return fromJS(removeTag);
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/tags/tags-reducer.js